import React, { Component } from "react";
import { connect } from "react-redux";

import { Mutation } from "react-apollo";
import gql from "graphql-tag";
import { Box } from "reflexbox";
import { toast } from "react-toastify";

import {
  Dialog,
  DialogType,
  DialogFooter
} from "office-ui-fabric-react/lib/Dialog";
import {
  CommandBarButton,
  DefaultButton,
  PrimaryButton
} from "office-ui-fabric-react/lib/Button";

import { ordersByShipmentId } from "../../queries/orders";

import ShipmentSelect from "../Dropdowns/_ShipmentSelect";
import { Formik, Form } from "formik";

class MoveOrderDialog extends Component {
  constructor() {
    super();
    this.state = {
      isModalVisible: false
    };
  }

  _showDialog = () => {
    this.setState({ isModalVisible: true });
  };

  _hideDialog = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const { selectedItems } = this.props;

    return (
      <Box>
        <CommandBarButton
          iconProps={{ iconName: "Move" }}
          styles={{ root: { padding: "10px" } }}
          title="Move orders"
          disabled={selectedItems && selectedItems.length !== 0 ? false : true}
          onClick={this._showDialog}
        />
        <Dialog
          hidden={!this.state.isModalVisible}
          onDismiss={this._hideDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: `Move ${selectedItems.length} orders`
          }}
          modalProps={{
            isBlocking: true
          }}
        >
          <Mutation mutation={MOVE_ORDERS_TO}>
            {(mutate, { data }) => (
              <Formik
                onSubmit={value => {
                  const targetShipmentId =
                    value.shipmentId !== "-1" ? value.shipmentId : null;
                  const shipmentId = this.props.shipment.id;
                  selectedItems.map(order => {
                    const id = order.id;
                    mutate({
                      refetchQueries: [
                        {
                          query: ordersByShipmentId,
                          variables: { id: targetShipmentId }
                        },
                        {
                          query: ordersByShipmentId,
                          variables: { id: shipmentId }
                        }
                      ],
                      variables: {
                        id: id,
                        shipmentId: targetShipmentId
                      }
                    })
                      .then(response => {
                        this._hideDialog();
                        // toast.success(`Orders moved !`);
                      })
                      .catch(err => {
                        toast.error(`${err}`);
                      });
                  });
                }}
                validate={(values, props) => {
                  const errors = {};
                  if (!values.shipmentId) {
                    errors.shipmentId = "Required";
                  }
                  return errors;
                }}
                render={props => (
                  <Form>
                    <ShipmentSelect
                      name="shipmentId"
                      label="Move orders to"
                      value={props.values.shipmentId}
                      onChange={props.setFieldValue}
                      onBlur={props.setFieldTouched}
                      error={props.errors.shipmentId}
                      touched={props.touched.shipmentId}
                    />
                    <DialogFooter>
                      <PrimaryButton
                        text="Submit"
                        type="submit"
                        disable={props.isSubmitting}
                      />
                      <DefaultButton onClick={this._hideDialog} text="Cancel" />
                    </DialogFooter>
                  </Form>
                )}
              />
            )}
          </Mutation>
        </Dialog>
      </Box>
    );
  }
}

const MOVE_ORDERS_TO = gql`
  mutation($id: Int!, $shipmentId: Int) {
    updateOrderById(
      input: { id: $id, orderPatch: { shipmentId: $shipmentId } }
    ) {
      order {
        id
        shipmentId
      }
    }
  }
`;


const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps)(MoveOrderDialog);



// WEBPACK FOOTER //
// ./src/common/Forms/_MoveOrderDialog.js